export const getComments = (comments, from) => {
   
    let currentComments = { ...comments };
    let finalComments = [];
    let newComments = [];
    let inReviewComments = [];
    let doneComments = [];
    if (currentComments) {
      newComments = currentComments.NEW?.map((comment) => ({
        ...comment,
        feedbackStatus: 0,
      }));
      if (currentComments.INREVIEW) {
        inReviewComments = currentComments.INREVIEW?.map((comment) => ({
          ...comment,
          feedbackStatus: 1,
        }));
      }
  
      if (currentComments.DONE) {
        doneComments = currentComments.DONE?.map((comment) => ({
          ...comment,
          feedbackStatus: 2,
        }));
      }
    }
    // if (comments.length > 0) {
  
    if (newComments && newComments.length > 0) {
      finalComments = [...newComments];
    }
  
    if (inReviewComments && inReviewComments.length > 0) {
      finalComments = [...finalComments, ...inReviewComments];
    }
  
    if (doneComments && doneComments.length > 0) {
      finalComments = [...finalComments, ...doneComments];
    }
  
    // finalComments = [...newComments, ...inReviewComments, ...doneComments];
    // }
  
    return finalComments;
  };
  